import type { ListCampaign } from '@mybonus/public';

import { CampaignCardOnClickData } from '../CampaignCard';
import { Wrapper, $CampaignCard } from './CampaignGrid.parts';

export type CampaignGridProps = {
	campaigns: ListCampaign[];
	onSelect?: (data: CampaignCardOnClickData) => void;
	onStoreClick?: (data: CampaignCardOnClickData) => void;
};

export function CampaignGrid(props: CampaignGridProps) {
	return (
		<Wrapper>
			{props.campaigns.map((c) => (
				<$CampaignCard
					key={c.id}
					store={c.store}
					campaign={c}
					onClick={props.onSelect}
					onStoreClick={props.onStoreClick}
					collapse
				/>
			))}
		</Wrapper>
	);
}
